export enum DirectPaths {
    HOME = "/",
    PLATFORM = "/platform",
    ALTS = "/alts",
    UNLISTED_SHARES = "/unlisted-shares",
    BULLION = "/bullion",
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    BULLION_POSTFIX_PATH = "/bullion",
    GOLD = "/gold/24-karat-gold",
    SILVER = "/silver/pure-silver",
    DOCVAULT = "/doc-vault",
    UNIBO = "/unibo",
    UE_DISCLAIMER = "/unlisted-shares/disclaimer",
    INVESTOR_RELATIONS = "/investor-relations",
    DISCLAIMER = "/disclaimer",
    CONTACT = "/contact",
    PRIVACY_POLICY = "/privacy-policy",
    TERMS_AND_CONDITIONS = "/terms-of-use",
    ANNOUNCEMENT = "/announcement",
    MILESTONE = "/milestone",
    POLICY_CENTER = "/policy-center",
    FD = "/fd",
    FD_POSTFIX_PATH = "/alts/fd",
}

export enum Subdomains {
    HOME = "dev",
}

export enum PathPrefixes {
    HOME = "/home",
}

type SubdomainConfig = {
    prefix: PathPrefixes;
    exceptions: DirectPaths[];
};

type RouteConfiguration = {
    [key in Subdomains]: SubdomainConfig;
};

export const routeConfig: RouteConfiguration = {
    [Subdomains.HOME]: {
        prefix: PathPrefixes.HOME,
        exceptions: [DirectPaths.UNLISTED_SHARES, DirectPaths.DOCVAULT, DirectPaths.UNIBO],
    },
};
